import { useMaterialAPI } from "../../../api/material/useMaterialAPI";
import { materialOutActions } from "./MaterialOutReducer";


export const useMaterialOut = () => {
    const api = useMaterialAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.materialOut.get(params);
              dispatch(materialOutActions.funGetmaterialOut(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.materialOut.post(data);
        },
        put: async (data) => {
          return await api.materialOut.put(data);
        },
        delete: async (params) => {
          return await api.materialOut.delete(params);
        }
    };
    return { request };
  };